import { Button } from "../../../components/button";

interface InputPhoneNumberProps {
  phoneNumber: string;
  onPhoneNumberChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
}
export const InputPhoneNumber: React.FunctionComponent<InputPhoneNumberProps> =
  ({ phoneNumber, onPhoneNumberChange, onSubmit }) => {
    const handleKeyEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter" || event.code === "Enter") {
        onSubmit();
      }
    };

    return (
      <div className="h-[100vh] flex flex-col justify-center">
        <div className="flex flex-1 items-center size-full bg-custombg-400 py-8 rounded">
          <div className="mx-4 w-full">
            <h1 className="text-primary text-xl">Masukkan Nomor Telepon</h1>
            <p className="py-4">
              Gunakan nomor telepon aktif Anda untuk menerima kode verifikasi{" "}
            </p>
            <div className="flex flex-row items-center pt-3">
              <p className="p-4 text-md">+62</p>
              <input
                onChange={onPhoneNumberChange}
                value={phoneNumber}
                type="number"
                pattern="[0-9]*"
                placeholder="8123456789"
                maxLength={13}
                onKeyDown={handleKeyEnter}
                className="flex rounded p-4 text-md w-full outline-none"
                id="auth-phone-input"
                data-testid="auth-phone-input"
              />
            </div>
          </div>
        </div>
        <div
          className="fixed mx-auto bottom-20 w-full sm:max-w-screen-mobile inset-x-0 px-4"
          id="auth-continue-btn"
          data-testid="auth-continue-btn"
        >
          <Button
            onClick={onSubmit}
            disabled={!phoneNumber || phoneNumber?.length < 8}
            size="full"
          >
            LANJUTKAN
          </Button>
        </div>
      </div>
    );
  };
